import React from 'react';
import CommonLayout from './CommonLayout';
import StaticLayout from './StaticLayout';

export default function Layout({ type, caseId, sections, imgSections }) {
  const Template = getTemplate(type);

  return <Template caseId={caseId} sections={sections} imgSections={imgSections} />;
}

function getTemplate(type) {
  switch (type) {
    case 'common':
      return CommonLayout;
    case 'static':
      return StaticLayout;
    default:
      return null;
  }
}
